<template>
	<form
		:id="props.id"
		accept-charset="UTF-8"
		action="https://traders.timothysykes.com/after-hours/night-tape-typ"
		method="GET"
		target="_blank"
		class="form-watchlist-cta mb-3 optin_form"
	>
		<div>
			<input
				:id="formLeadId"
				name="email"
				type="email"
				placeholder="Your email address"
				class=""
				required
			/>

			<div
				class="error_email text-xs text-red-700 pb-5 text-start !text-xs"
				style="display: none"
			>
				Enter a valid email address.
			</div>
		</div>
		<input
			type="hidden"
			name="funnel_id"
			:value="funnel_id"
		/>
		<input
			type="hidden"
			name="page_id"
			value="night-tape-optin"
		/>
		<input
			type="hidden"
			name="page_type"
			value="optin"
		/>
		<input
			type="hidden"
			name="page_revision"
			value="A"
		/>
		<input
			type="hidden"
			name="action_id"
			value="opt_in"
		/>

		<button
			type="submit"
			:class="`cta btn `"
		>
			Get FREE Watchlist
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M14 4.92993L12.5 6.42993L17.0703 11.0002H3V13.0002H17.0703L12.5 17.5706L14 19.0706L21.0703 12.0002L14 4.92993Z"
					fill="#1E293B"
				/>
			</svg>
		</button>
	</form>

	<div
		v-if="!isHero"
		class="hero-disclaimer-text-container leading-normal flex flex-col -top-2 relative"
	>
		<span
			:class="[
				'text-xs text-white/[0.5] bg-primary-900/[0.8] leading-normal',
				{ 'hero-disclaimer-text': isHero }
			]"
		>
			By submitting your email, you give us permission to 1. Sign you up for Tim's
			After-Hours Watchlist, The Night Tape, 2. Send free ongoing updates via our
			independent email newsletter,
			and 3. Share carefully selected marketing offers for products and services we
			think will interest you. You can unsubscribe at any time.
			<NuxtLink
				to="/terms-of-service"
				class="text-white underline"
			>
				See Terms of Service here.
			</NuxtLink>
		</span>
	</div>
</template>
<script setup>
// After-hours Night Tape opt-in (traders.timothysykes.com/after-hours/night-tape)
const funnel_id = "ts_wl";
const page_id = "night-tape-optin";

// Tracking APIs and Script initialization parameters - matching PHP configuration
const tracking_key =
	"UV5pQG9AencxZEhuekdremIzZnpyIVppWT1vLUguQVR2OiVIOlJJfV91azVFNGlxKXVTalcsOHAzajohUHM+cQ==";
const tracking_host = "ky85ws0f10";
const mkt_key = "Q'xD@ss^+qe{sk2L]q33,r-UW4FUTXW)";
const mkt_host = "mktlap";
const mkt_tld = "timothysykes.com";

const debug = false;

const props = defineProps({
	id: {
		type: String,
		required: true
	},
	isHero: {
		type: Boolean,
		default: true
	}
});

const formLeadId = computed(() => {
	return `inf_field_Email-ts-watchlist-optin-int-a`;
	// return `inf_field_Email-${props.id}`;
});

const mkt_script_url = "https://hgevt001.timothysykes.com/mkt-weet.js";

// Script ID for the tracking script
const SCRIPT_ID = "mktlsid";

// Generate head script for top level tracking parameters (equivalent to PHP generateHeadScripts)
// Using the exact page ID from the working configuration
useHead({
	script: [
		{
			innerHTML: `
				window.weet_page_id = '${page_id}';
				window.weet_page_type = 'optin';
				window.weet_page_rev = 'A';
				window.weet_funnel_id = '${funnel_id}';
			`
		},
		{
			async: true,
			id: SCRIPT_ID,
			type: "text/javascript",
			src: mkt_script_url,
			tagPriority: "low",
			"data-h": tracking_host,
			"data-k": tracking_key,
			"data-l": debug ? "1" : undefined,
			"data-dbg": debug ? "0" : undefined,
			"data-dbglog": debug ? "1" : undefined,
			"data-ep": debug ? "test" : undefined,
			"data-mak": mkt_key,
			"data-mtld": mkt_tld,
			"data-mhst": mkt_host,
			"data-phf": "1",
			"data-mgp": "1",
			"data-mofc": "optin_form"
		}
	]
});

// Handle SPA navigation - the useHead script won't re-execute on client-side navigation
// So we need to detect SPA navigation and manually reinitialize the tracking script
onMounted(async () => {
	if (!process.client) return;

	// Track instance count to handle multiple forms on same page
	if (typeof window.__mktWeetInstanceCount === "undefined") {
		window.__mktWeetInstanceCount = 0;
	}
	window.__mktWeetInstanceCount++;

	// Only first instance should manage the script
	if (window.__mktWeetInstanceCount > 1) {
		return;
	}

	// Check if this is SPA navigation (script was previously initialized)
	const isSpaNavigation = window.__mktWeetInitialized === true;

	if (isSpaNavigation) {
		console.log("SPA navigation detected - reinitializing mkt-weet");

		// Re-set window properties (in case they were modified)
		window.weet_page_id = page_id;
		window.weet_page_type = "optin";
		window.weet_page_rev = "A";
		window.weet_funnel_id = funnel_id;

		// Wait for DOM to be ready
		await nextTick();

		// Remove existing mkt-weet scripts
		document.querySelectorAll(`#${SCRIPT_ID}`).forEach((el) => el.remove());
		document
			.querySelectorAll('script[src*="mkt-weet.js"]')
			.forEach((el) => el.remove());

		// Small delay for cleanup
		await new Promise((resolve) => setTimeout(resolve, 100));

		// Re-inject script with cache-busting to force re-execution
		const script = document.createElement("script");
		script.async = true;
		script.id = SCRIPT_ID;
		script.type = "text/javascript";
		script.src = `${mkt_script_url}?_spa=${Date.now()}`;
		script.dataset.h = tracking_host;
		script.dataset.k = tracking_key;
		if (debug) {
			script.dataset.l = "1";
			script.dataset.dbg = "0";
			script.dataset.dbglog = "1";
			script.dataset.ep = "test";
		}
		script.dataset.mak = mkt_key;
		script.dataset.mtld = mkt_tld;
		script.dataset.mhst = mkt_host;
		script.dataset.phf = "1";
		script.dataset.mgp = "1";
		script.dataset.mofc = "optin_form";

		document.head.appendChild(script);
		console.log("mkt-weet script re-injected for SPA navigation");
	} else {
		// Mark initial load complete
		window.__mktWeetInitialized = true;
	}
});

// Cleanup on unmount
onUnmounted(() => {
	if (!process.client) return;

	if (window.__mktWeetInstanceCount > 0) {
		window.__mktWeetInstanceCount--;
	}
});
</script>
<style lang="scss">
@import "@assets/utils.scss";

.form-watchlist-cta {
	display: flex;
	width: 100%;
	padding: 6px;
	align-items: center;
	border-radius: 8px;
	background: $primary-50;
	justify-content: space-between;
	flex-direction: column;

	@include breakpoint(md) {
		flex-direction: row;
		gap: 10px;
	}

	@include breakpoint(md) {
		width: 500px;
	}

	button {
		width: 100%;
		justify-content: center;
		@include breakpoint(md) {
			width: auto;
		}
	}

	input {
		background-color: transparent;
		color: $neutral-800;
		padding: 10px 12px;
		font-size: 18px;
		font-weight: 400;
		line-height: 160%;
		width: 100%;

		&::placeholder {
			font-weight: 400;
			color: $neutral-400;
			padding: 10px 12px;
		}

		@include breakpoint(lg) {
			padding: 10px;
		}
	}
}

.apply-challenge-section {
	background-color: $primary-900;
	background-image: url("/images/assets/texture.svg");
	background-position: center;

	&.pb-0 {
		padding-bottom: 0;
	}
}

.ready-to-take-action-1 {
	display: none;
	margin-left: auto;
	margin-right: auto;

	@include breakpoint(lg) {
		display: block;
	}
	@include breakpoint(xl) {
		margin-left: auto;
	}
}

.ready-to-take-action-2 {
	display: block;
	margin-left: auto;
	margin-right: auto;
	@include breakpoint(lg) {
		display: none;
	}
}

.hero-disclaimer-text {
	&[data-expanded="false"] {
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		text-overflow: ellipsis;

		@include breakpoint(md) {
			display: block;
			-webkit-line-clamp: unset;
			line-clamp: unset;
			overflow: visible;
		}
	}

	.read-more-link {
		cursor: pointer;
		text-decoration: underline;
		margin-left: 4px;
		color: white;
		display: inline;

		@include breakpoint(md) {
			display: none;
		}
	}
}

.btn.cta {
	display: flex;
	padding: 12px 16px;
	align-items: center;
	gap: 4px;
	border-radius: 8px;
	background: $warning-500;
	color: $neutral-800;
	text-align: center;
	font-family: Fira Sans;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 25px;
	white-space: nowrap;

	&.secondary {
		background-color: $primary-700;
		color: white;
		&:hover {
			background-color: $primary-500;
		}
	}

	@include breakpoint(md) {
		padding: 12px 24px;

		font-size: 18px;
	}

	&:hover {
		background: $secondary-500;
	}
}

a.btn.cta {
	display: inline-flex;
}
</style>
